export enum StorageType {
  Cifs = 'Cifs',
  Alfresco = 'Alfresco',
  AwsS3 = 'AwsS3',
  Url = 'Url',
}

export enum StorageTypeId {
  Cifs = 1,
  Alfresco = 2,
  AwsS3 = 3,
  Url = 4,
}
